import { styled } from '@mui/material';

export const SiteLink = styled('a')(({ theme }) => ({
    color: theme.palette.grey[800],
    textDecoration: 'none',
    cursor: 'pointer',

    '&:hover': {
        color: theme.palette.primary.main,
    },
}));
